export enum StorageProviderType {
  AmazonS3 = 'AMAZON_S3',
  Box = 'BOX',
  Dropbox = 'DROPBOX',
  OneDrive = 'ONEDRIVE',
  GoogleDrive = 'GOOGLE_DRIVE',
  SharePoint = 'SHARE_POINT',
}
